import React, { useState } from 'react';
import { Box, Heading, Text } from '@medely/ui-kit';
import { DebitCardForm } from '../../../components/DebitCardForm';
import { BankAccountForm } from './components/BankAccountForm';
import { DirectDepositSwitchButton } from '@mp/components/directDeposit/DirectDepositSwitchButton';

type Props = {
  onError: (error?: any) => void;
  onSuccess: () => void;
};

export const DirectDeposit = ({ onError, onSuccess }: Props) => {
  const [isCardSelected, setIsCardSelected] = useState(true);

  return (
    <Box>
      <Heading size="xs" data-testId="financial-direct-deposit-title">
        Direct deposit
      </Heading>
      <Box pt={1}>
        <Text size="m" color="text.secondary">
          With our secure payment system, you can choose to connect either your bank account or
          debit card to receive your payouts.
        </Text>
      </Box>
      <Box mt={3}>
        <DirectDepositSwitchButton isCardSelected={isCardSelected} onChange={setIsCardSelected} />
      </Box>
      <Box mt={3}>
        {isCardSelected ? (
          <DebitCardForm onSuccess={onSuccess} />
        ) : (
          <BankAccountForm onError={onError} onSuccess={onSuccess} />
        )}
      </Box>
    </Box>
  );
};
